export default function () {
  let window = `relatorio.leiloes.veiculosConfirmacaoDados`
  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: 'Confirmação de Dados de Veículos para Leilão',
    width: '600',
    height: '300',
    minHeight: '300px',
    backdrop: false,
    maximize: false,
    clickOutside: false,
    windowClass: 'erp-window',
    contentClass: 'overflow-hidden',
    props: {
    }
  }, () => import('./VeiculosConfirmacaoDados.vue'))
    .then((wid) => {
      console.log(wid)
    }) // return wid
}
